import {useTranslation} from '@aboutyou/i18n';
import {useHydrationDone} from '@aboutyou/lazy-imports';
import {useRecentFullUrl} from '@aboutyou/router';
import {COLORS, GenericIconName, Icon} from '@aboutyou/ui-components';
import {useOS} from '@aboutyou/utils';
import {styled} from '@linaria/react';
import React from 'react';
import {StyledCircleButton as CircleButton} from './shared';

const ShareButtonComponent: React.FC<{
  url?: string;
  title?: string;
  text?: string;
  className?: string;
  style?: React.CSSProperties;
  iconColor?: COLORS;
}> = ({url, title, text, iconColor, ...rest}) => {
  const {t} = useTranslation();
  const os = useOS();
  const fallbackUrl = useRecentFullUrl();
  const isHydrationDone = useHydrationDone();

  const supportsShare =
    // eslint-disable-next-line ssr-friendly/no-dom-globals-in-react-fc
    isHydrationDone && 'navigator' in globalThis && 'share' in navigator;

  if (!supportsShare) {
    return null;
  }

  const defaultConfig = {
    // eslint-disable-next-line ssr-friendly/no-dom-globals-in-react-fc
    title: 'document' in globalThis ? document.title : undefined,
    text: undefined,
    url: fallbackUrl,
  };

  const asset =
    os === 'android' ? GenericIconName.ShareAndroid : GenericIconName.Share;

  return (
    <StyledCircleButton
      onClick={() => {
        navigator.share({
          ...defaultConfig,
          url,
          title,
          text,
        });
      }}
      aria-label={t('Share page')}
      {...rest}
    >
      <Icon fill={iconColor || COLORS.Grey1} size="S" asset={asset} />
    </StyledCircleButton>
  );
};

const StyledCircleButton = styled(CircleButton)`
  box-shadow: none;

  &:focus-visible {
    outline: 2px auto Highlight;
    outline: 2px auto -webkit-focus-ring-color;
  }
`;

export const ShareButton = styled(ShareButtonComponent)``;
